export const BrandAccentVerticalSvg = () => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: purely decorative, no need for title
  <svg width="38" height="124" viewBox="0 0 38 124" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 4.12827C0 1.84829 1.84829 0 4.12827 0H35.9988C37.3278 0 38.1547 1.44287 37.483 2.58957L3.18889 61.1305C2.87433 61.6675 2.87433 62.3325 3.18889 62.8695L37.483 121.41C38.1547 122.557 37.3278 124 35.9988 124H4.12827C1.84829 124 0 122.152 0 119.872V4.12827Z"
      fill="currentColor"
    />
  </svg>
);
